import classNames from 'classnames';
import React from 'react';
import { createFieldRenderer } from '../helpers';

/**
 * The renderer component that form field components SHOULD use when no other renderer is specified.
 */
const DefaultFieldRenderer = createFieldRenderer(({
    className = '',
    factory,
    innerClassName = '',
    error = null,
    label = null,
    ...props
}) => <div className={classNames(
    className,
    'form-group',
    {[`field-renderer-${props.name}`]: props.name },
    { 'has-error': !!error }
)}>
    {label &&
        <label className="control-label">{label}</label>
    }
    {factory({
        ...props,
        className: classNames(innerClassName),
        error,
        label,
    })}
    {(error && typeof error === 'string') &&
        <p className="text-danger">
            {error}
        </p>
    }
</div>);

export default DefaultFieldRenderer;
